import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from "react";

/**
 * Lets a page put the open record into the desktop header breadcrumb
 * ("Acme / Sales / Sales › #INV-104"), with the page crumb acting as "back to list".
 */
const PageHeadingContext = createContext({ heading: null, setHeading: () => {} });

export function PageHeadingProvider({ children }) {
  const [heading, setHeading] = useState(null);
  const value = useMemo(() => ({ heading, setHeading }), [heading]);
  return <PageHeadingContext.Provider value={value}>{children}</PageHeadingContext.Provider>;
}

export function usePageHeading() {
  return useContext(PageHeadingContext);
}

/** Shows `label` as the breadcrumb tail while mounted / while label is set. */
export function useSetPageHeading(label, onBack) {
  const { setHeading } = usePageHeading();
  const onBackRef = useRef(onBack);
  onBackRef.current = onBack;

  useEffect(() => {
    if (!label) return undefined;
    setHeading({ label, onBack: () => onBackRef.current?.() });
    return () => setHeading(null);
  }, [label, setHeading]);
}

export default PageHeadingContext;
